import { Shop } from "../../domain/Shop";
import { ShopRepository } from "../../domain/ShopRepository";

export class ShopNoteAdder{
    private _repository: ShopRepository;
    constructor(repository: ShopRepository){
        this._repository = repository;
    }
    invoke(shop: Shop, note: string){
        return this._repository.addNote(shop, note);
    }
}